import styled from 'styled-components/macro';

// Step 3 Form Styles
export const OfferLetterFormCard = styled.div`
  background: ${({ theme }) => theme.color.gray[50]};
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
`;

export const OfferLetterFormCardTitle = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: ${({ theme }) => theme.color.gray[300]};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const OfferLetterFormRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const OfferLetterFormGroup = styled.div<{ $full?: boolean }>`
  flex: ${({ $full }) => ($full ? '1 1 100%' : '1 1 0')};
  min-width: 0;
`;

export const OfferLetterFormLabel = styled.label`
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.gray[300]};
  margin-bottom: 3px;
`;

export const OfferLetterFormInput = styled.input`
  width: 100%;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  background: ${({ theme }) => theme.color.white};

  &::placeholder {
    color: ${({ theme }) => theme.color.gray[200]};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.color.blue[600]};
  }
`;

export const OfferLetterFormSelect = styled.select`
  width: 100%;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  background: ${({ theme }) => theme.color.white};
  appearance: auto;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.color.blue[600]};
  }
`;

export const OfferLetterFormTextarea = styled.textarea`
  width: 100%;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  background: ${({ theme }) => theme.color.white};
  resize: vertical;
  display: block;

  &::placeholder {
    color: ${({ theme }) => theme.color.gray[200]};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.color.blue[600]};
  }
`;

export const OfferLetterAddContactButton = styled.button`
  font-size: 11px;
  color: ${({ theme }) => theme.color.blue[600]};
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
  margin-top: 4px;
`;

export const OfferLetterRemoveContactButton = styled.button`
  position: absolute;
  top: 8px;
  right: 0;
  background: none;
  border: none;
  color: ${({ theme }) => theme.color.red[700]};
  cursor: pointer;
  font-size: 11px;
  padding: 2px 4px;
`;

export const OfferLetterContactEntry = styled.div`
  padding: 8px 0;
  position: relative;

  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.color.gray[200]};
  }
`;

export const OfferLetterFormError = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.color.red[700]};
  margin-top: 2px;
`;
